<template>
  <main
    data-component="checkout-success-page"
    data-fullscreen
    v-background-color="$store.getters['ui/getBackgroundColor']"
    v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
  >
    <main-header data-element="main-header" :hideTableNumber="true" />

    <success
      v-if="pageReady"
      :orderRef="successData.orderRef"
      :orderTime="successData.time"
      :lineItems="successData.basket.lines"
      :getProduct="getProduct"
      :total="successData.total"
      buttonLink="buttonLink"
      buttonText="buttonText"
      :basketCount="successData.basketCount"
      :tableNumber="successData.tableNumber"
      :collectOnly="collectOnly"
      :orderNumber="orderNumber"
    />
    <sticky-footer>
      <btn
        text="Homepage"
        href="/"
        :link="true"
        size="md"
        :fontStyle="{
          ...this.$store.getters['ui/getBodyCopyFontDetail']('normal'),
          textSize: '18px',
        }"
        :backgroundColor="$store.getters['ui/getSecondaryColor']"
        :hasWrapper="true"
      />
    </sticky-footer>
  </main>
</template>

<script>
import MainHeader from "@/components/ui/MainHeader";
import Success from "@/components/checkout/Success";
import StickyFooter from "@/components/ui/StickyFooter";
import Btn from "@/components/ui/Btn";
import { mapGetters } from "vuex";
export default {
  name: "checkout-success-page",
  data: () => {
    return {
      pageReady: null,
      showDetails: false,
      successData: {},
      menus: null,
    };
  },
  components: {
    MainHeader,
    Success,
    StickyFooter,
    Btn,
  },
  computed: {
    ...mapGetters({
      site: "getSite",
    }),
    ...mapGetters("iOrderCheckout", {
      orderNumber: "getOrderNumber",
    }),
    collectOnly() {
      return this.site && this.site.collectOnly;
    },
    getTime() {
      const now = new Date();

      return `${now.getHours().toString()}:${this.getMinutes}`;
    },
    getMinutes() {
      const now = new Date();

      if (now.getMinutes() < 10) {
        return `0${now.getMinutes().toString()}`;
      } else {
        return now.getMinutes().toString();
      }
    },
  },
  methods: {
    init() {
      this.$store.dispatch("checkNecessaryDataToProceed");

      this.menus = this.$store.getters["iOrderCore/getMenus"];

      this.successData = Object.assign(
        {},
        {
          basketCount: this.$store.getters["iOrderCore/getBasketCount"],
          orderRef: this.$store.getters["iOrderCheckout/getSuccessData"]
            .uniqueRef,
          time: this.getTime,
          email: this.$store.getters["iOrderCheckout/getSuccessData"]
            .receiptEmail,
          basket: this.$store.getters["iOrderCore/getBasket"],
          total: this.$store.getters["iOrderCheckout/getBasketTotal"],
          tableNumber: this.$store.getters["iOrderCore/getTableNumber"],
        }
      );
      this.pageReady = true;
      this.$store.dispatch("clearState");
    },
    getProduct(productId) {
      let productDetail = null;
      Object.values(this.menus).forEach((menu) => {
        const productObject = menu.aztec.products.find((product) => {
          return product.id === productId;
        });
        if (productObject) productDetail = productObject;
      });
      return productDetail;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
[data-component="checkout-success-page"] {
}
</style>
